import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getLocationMetrics(locationId, params = {}) {
  return axios.get(`/ajax/locations/${locationId}/metrics`, { params })
}
export function syncLocationMetrics(locationId) {
  return axios.post(`/ajax/locations/${locationId}/metrics/sync`)
}
